import {createGate} from "effector-react";
import DashboardProps from "../props/DashboardProps";
import DashboardType from "../entities/DashboardType";

const DashboardGate = createGate<DashboardType>()
export default DashboardGate